module.exports = __webpack_public_path__ + "static/media/A1.b3c649f3.jpg";